import React from 'react';

import { DataController as DataControllerCore } from '../../../../core/react/DataController.js';

export const DataController = () => (
  <DataControllerCore brandName="Aftenposten" />
);
